export const ACTIONS = {
  SET_STRING: "SET_STRING",
  DELETE_STRING: "DELETE_STRING",
  SET_SPACE: "SET_SPACE",
  SET_TAB: "SET_TAB",
  SET_NEWLINE: "SET_NEWLINE",
  CLEAR_ALL: "CLEAR_ALL",
};
